export const messages = {
    'integrations.menu.item': 'Integrations',

    'integrations.modal.title': 'Integrations',
    'integrations.modal.subtitle': 'Pick the procedures you want to export and the version to export for each of them.',

    'integrations.deployment.label': 'Deployment',
    'integrations.deployment.placeholder': 'Select a deployment',
    'integrations.deployment.empty': 'No deployment available',

    'integrations.settings.title': 'Export settings',
    'integrations.settings.split': 'Split',
    'integrations.settings.createWbtCourse': 'Create WBT course',
    'integrations.settings.playerTemplate': 'Player template',
    'integrations.settings.contentFolder': 'Content folder',
    'integrations.settings.contentProvider': 'Content provider',
    'integrations.settings.contentServer': 'Content server',
    'integrations.settings.owner': 'Owner',

    'integrations.search.placeholder': 'Search procedures',

    'integrations.list.empty': 'There are no procedures in this company yet.',
    'integrations.list.noResults': 'No procedure matches your search.',
    'integrations.list.selectAll': 'Select all',
    'integrations.list.clearSelection': 'Clear selection',
    'integrations.list.noVersions': 'No versions uploaded',

    'integrations.version.label': 'Version',
    'integrations.version.latest': 'Latest',

    'integrations.selection.suffix': 'selected',

    'integrations.export.button': 'Export',
    'integrations.cancel.button': 'Cancel',

    'integrations.toast.success': 'The export file has been downloaded.',
    'integrations.toast.error': 'Something went wrong while exporting the selected procedures.',
}
